import React, { useState } from 'react';
import { Layout, Menu } from 'antd';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import map from 'lodash/map';
import get from 'lodash/get';
import MenuKeys from '../../constants/siderMenu';
import { hasAnyPermission } from '../../utilities/helpers';
import Logo from '../../assets/common/logo.png';

const { Sider } = Layout;
const { SubMenu } = Menu;

function LayoutSider() {
  const [collapsed, setCollapsed] = useState(false);
  const role = useSelector((state) => get(state, 'auth.role'));

  return (
    <Sider
      collapsed={collapsed}
      width={240}
      collapsedWidth={68}
      onCollapse={() => {
        setCollapsed(true);
      }}
      className="layout-sider fixed-sider"
    >
      <div className="sider-logo-section">
        <img src={Logo} alt="" />
      </div>
      <div className="side-menu-container">
        <Menu mode="inline" className="sider-menu">
          {map(MenuKeys, (menu) => {
            const hasChild = get(menu, 'children', []).length > 0;
            const hasPermission = hasAnyPermission(get(menu, 'allowedRoles'), [
              get(role, 'role_code'),
            ]);
            if (hasPermission) {
              return hasChild ? (
                <SubMenu
                  key={get(menu, 'key')}
                  icon={get(menu, 'icon')}
                  id={get(menu, 'id')}
                  title={get(menu, 'title')}
                  className="menu-item"
                >
                  {map(get(menu, 'children'), (subMenu) => (
                    <Menu.Item
                      key={get(subMenu, 'key')}
                      icon={get(subMenu, 'icon')}
                      id={get(subMenu, 'id')}
                      className="menu-item"
                    >
                      <Link to={get(subMenu, 'redirect')} className="title">
                        {get(subMenu, 'title')}
                        {/* <Text type="secondary">{get(menu, 'title')}</Text> */}
                      </Link>
                    </Menu.Item>
                  ))}
                </SubMenu>
              ) : (
                <Menu.Item
                  key={get(menu, 'key')}
                  icon={get(menu, 'icon')}
                  id={get(menu, 'id')}
                  className="menu-item"
                >
                  <Link to={get(menu, 'redirect')} className="title">
                    {get(menu, 'title')}
                    {/* <Text type="secondary">{get(menu, 'title')}</Text> */}
                  </Link>
                </Menu.Item>
              );
            }
            return null;
          })}
        </Menu>
      </div>
    </Sider>
  );
}

export default LayoutSider;
